// src/router/index.ts
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const WP_BASE = 'https://compotek.it'
const WP_AUTH = `${WP_BASE}/wp-json/compotek/v1/auth`

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('../views/HomePage.vue'),
    meta: { requiresWpAuth: true },
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('../views/DashboardPage.vue'), // <-- dentro router-view di HomePage
      },
      {
        path: 'invoices-history',
        name: 'invoices-history',
        component: () => import('../views/InvoicesHistoryPage.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginPage.vue'),
    meta: { guestOnly: true },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

let cachedWpAuth: boolean | null = null
let cacheTs = 0
const CACHE_MS = 10_000

function getToken(): string {
  try {
    return localStorage.getItem('cf_token') || ''
  } catch {
    return ''
  }
}

function clearToken() {
  try {
    localStorage.removeItem('cf_token')
  } catch {
    /* noop */
  }
}

async function isWpLoggedIn(): Promise<boolean> {
  if (cachedWpAuth !== null && Date.now() - cacheTs < CACHE_MS) return cachedWpAuth

  const token = getToken()
  if (!token) {
    cachedWpAuth = false
    cacheTs = Date.now()
    return false
  }

  try {
    const res = await fetch(WP_AUTH, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })

    const data: any = await res.json().catch(() => ({}))

    cachedWpAuth = !!data?.loggedIn
    cacheTs = Date.now()

    if (!cachedWpAuth) clearToken()

    return cachedWpAuth
  } catch {
    cachedWpAuth = false
    cacheTs = Date.now()
    return false
  }
}

// reset cache subito dopo login/logout
window.addEventListener('cf-auth-changed', () => {
  cachedWpAuth = null
  cacheTs = 0
})

router.beforeEach(async (to) => {
  const needsAuth = to.matched.some((r) => r.meta.requiresWpAuth)
  const guestOnly = to.matched.some((r) => r.meta.guestOnly)

  const logged = await isWpLoggedIn()

  if (needsAuth && !logged) {
    return { name: 'login' }
  }

  if (guestOnly && logged) {
    return { name: 'home' }
  }

  return true
})

export default router